class FooterMenu extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['menu']
  }

  constructor () {
    super()

    this.desktopMediaQuery = window.matchMedia('(min-width: 768px)')

    this.handleBreakpointChange = this.handleBreakpointChange.bind(this)
    this.handleMenuToggle = this.handleMenuToggle.bind(this)
  }

  setupListeners () {
    this.listeners.add(
      this.desktopMediaQuery,
      'change',
      this.handleBreakpointChange,
    )

    this.els.menu.elements.forEach((menu) => {
      this.listeners.add(menu, 'toggle', this.handleMenuToggle)
    })
 
    this.updateMenus()
  }

  handleBreakpointChange () {
    this.updateMenus()
  }

  /**
   * @param {Event} event
   */
  handleMenuToggle (event) {
    if (this.desktopMediaQuery.matches) return

    const menu = event.currentTarget

    menu.dataset.mobileOpen = String(menu.open)
  }

  updateMenus () {
    this.els.menu.elements.forEach((menu) => {
      if (this.desktopMediaQuery.matches) {
        this.storeMobileState(menu)

        menu.open = true

        return
      }

      this.restoreMobileState(menu)
    })
  }

  /**
   * @param {HTMLDetailsElement} menu
   */
  storeMobileState (menu) {
    if ('mobileOpen' in menu.dataset) return

    menu.dataset.mobileOpen = String(menu.open)
  }

  /**
   * @param {HTMLDetailsElement} menu
   */
  restoreMobileState (menu) {
    menu.open = menu.dataset.mobileOpen === 'true'
  }
}

if (!customElements.get('footer-menu')) {
  customElements.define('footer-menu', FooterMenu)
}